import React from 'react';

const CcrSubmitSuccess = (props) => {

    return (
        <div className="container">
            {/* <br style={{height:"10vh"}}/> */}
            
            <h3 style={{fontSize:"4vh", marginTop:"6vh"}}>Success!</h3>
            <br/>
            <span style={{fontSize:"2vh"}}>CS-Chat has received your request and will respond via email shortly.</span>

        </div>
    );
}

export default CcrSubmitSuccess;